var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"delete icon",class:{disabled: _vm.disabled},attrs:{"title":_vm.deleteTitle,"role":"button","href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.handleClick.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }